module.exports = __webpack_public_path__ + "static/media/guests.fe60d917.svg";